import {API_URL} from 'api/constants'

// TODO remove
export const ITEMS = `${API_URL}/v2/items`

export const V2_ITEMS = `${API_URL}/v2/items`

export const V1_ITEMS = `${API_URL}/v1/items`

export const V1_ITEM_BY_ID = (id) => `${V1_ITEMS}/${id}`

export const V1_IMPORT_ITEMS_TEMPORARY = `${V1_ITEMS}/import_items_temporary`

export const V1_IMPORT_ITEMS = `${V1_ITEMS}/import_items`

export const V1_IMPORT_ITEMS_TEMPLATE = `${V1_ITEMS}/import_items_template`



// WEBPACK FOOTER //
// ./app/api/items/constants.js